export const API_BASE = "https://service-spotrack-dubphwg5cae3f4da.centralindia-01.azurewebsites.net/api/v1";
export const TOKEN_SLUG = "washwooshToken";
export const COMPANY_ID="3D9DBE71-695C-4C4B-840A-C26254C89612";